import React, { useState, useMemo } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import UserTable from '../../../components/tables/UserTable';

const UserManagement = () => {
  const location = useLocation();

  // Sample data generator for each user role
  const generateSampleData = (role, count = 50) => {
    const statuses = ['Active', 'Inactive'];
    const cities = ['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad'];
    
    return Array.from({ length: count }, (_, i) => ({
      id: `${role.substring(0, 3).toUpperCase()}${String(i + 1).padStart(4, '0')}`,
      name: `User ${i + 1}`,
      email: `user${i + 1}@${role.replace(/\s+/g, '')}.com`,
      phone: `+91 ${Math.floor(Math.random() * 9000000000) + 1000000000}`,
      city: cities[Math.floor(Math.random() * cities.length)],
      status: statuses[Math.floor(Math.random() * statuses.length)],
      joinDate: new Date(2020 + Math.floor(Math.random() * 5), Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1)
        .toISOString().split('T')[0]
    }));
  };

  // Initialize user role data with state
  const [userRolesData, setUserRolesData] = useState({
    'super-distributor': {
      label: 'Super Distributor',
      data: generateSampleData('super-distributor', 30)
    },
    'master-distributor': {
      label: 'Master Distributor',
      data: generateSampleData('master-distributor', 45)
    },
    'distributor': {
      label: 'Distributor',
      data: generateSampleData('distributor', 60)
    },
    'retailer': {
      label: 'Retailer',
      data: generateSampleData('retailer', 80)
    },
    'api-partner': {
      label: 'API Partner',
      data: generateSampleData('api-partner', 25)
    },
    'sales-force': {
      label: 'Sales Force',
      data: generateSampleData('sales-force', 35)
    },
    'support': {
      label: 'Support',
      data: generateSampleData('support', 20)
    }
  });

  // URL se current role detect karna
  const currentRole = useMemo(() => {
    const pathParts = location.pathname.split('/');
    return pathParts[pathParts.length - 1];
  }, [location.pathname]);

  // Current role ka data
  const currentRoleData = userRolesData[currentRole] || userRolesData['super-distributor'];

  // Handle data change (add/edit user)
  const handleDataChange = (newData) => {
    setUserRolesData(prev => ({
      ...prev,
      [currentRole]: {
        ...prev[currentRole],
        data: newData
      }
    }));
  };

  return (
    <Container fluid className="">
      <UserTable
        data={currentRoleData.data}
        userRole={currentRoleData.label}
        onDataChange={handleDataChange}
      />
    </Container>
  );
};

export default UserManagement;

